<template>
  <!-- <div class="groupDivide"> -->
	<!--
	<ul class="groupItem featureList">
		<li v-for="(feature, index) in list" :feature="feature" :index="index">{{feature}}</li>
	</ul>
	-->
	<div class="groupItem featureList">
    <Analytics :feature="analytics" class="featureItem"/>
		<FeatureItem class="featureItem" v-for="(feature, index) in list" :key="index" :feature="feature" :index="index"></FeatureItem>
	</div>
    <!-- <PieContainer class="groupItem" :pieData="dummyData"></PieContainer> -->
  <!-- </div> -->
</template>


<script>
import FeatureItem from './FeatureItem.vue'

import PieContainer from './pieContainer.vue'
import Analytics from './Analytics.vue';

export default {
  name: 'evenPostSummary',
    components: {
  FeatureItem,
  PieContainer,
  Analytics
  },
  data() { return  {
	  toggleData: false,
    analytics: 		  { 'title' : 'Analytics & Reporting',  'img': 'afterEvent.jpeg',
		  'blurb' :  'Access intuitive, real-time analytics and reporting for immediate and detailed insight into your event.' },
	  list: [
		  { 'title' : 'Lessons Learned (Sensors)',  'img': 'ProgramManagement.jpg',
		  'blurb' : 'Utilize our long history of event management and lessons learned to make the most of your event without making the mistakes.'},
		  { 'title' : 'Post Event Communication (Thank You / Survey)',  'img': 'ExperientialMarketing.jpg',
		  'blurb' : 'Listen to the audience with feedback from a customizable post-event poll or survey.'}
	  ]
    }
  },
  mounted: function () {
    this.$nextTick(function() {
      window.setInterval(() => {this.changeData()}, 3000);
    })
  },
  methods: {
    changeData() {
        this.toggleData = this.toggleData ? false:true;
    }
  },
  computed: {
    dummyData() {
      if(this.toggleData) {
        return this.dummyData1;
      }
      else {
        return this.dummyData2;
      }
    },
    dummyData1() {
      let graphData = [
        {'label': 'Android', 'amount': 467}, 
        {'label': 'iOS', 'amount': 784}, 
        {'label': 'BlackBerry', 'amount': 54}];

      let excelData = [
        {'label': 'Android 8.1', 'amount': 20},
        {'label': 'Android 8.0', 'amount': 56}, 
        {'label': 'Android 9.0', 'amount': 288}, 
        {'label': 'Android 6.0.1', 'amount': 23}, 
        {'label': 'Android 7.0', 'amount': 13}, 
        {'label': 'Android 7.1', 'amount': 45}, 
        {'label': 'Android 10.0', 'amount': 22}, 
        {'label': 'iOS 12.0', 'amount': 86},
        {'label': 'iOS 11.4', 'amount': 344}, 
        {'label': 'iOS 11.3', 'amount': 46}, 
        {'label': 'iOS 11.0', 'amount': 120}, 
        {'label': 'iOS 10.3.3', 'amount': 97}, 
        {'label': 'iOS 10.2', 'amount': 27}, 
        {'label': 'iOS 8.4.1', 'amount': 64}, 
        {'label': 'BlackBerry', 'amount': 54}];

      let data = {
        title : "Devices Used By Attendees",
        dataExcel : excelData,
        data: graphData
      };

      return data;
    },
    dummyData2() {
      let graphData = [
        {'label': 'Android', 'amount': 656}, 
        {'label': 'iOS', 'amount': 594}, 
        {'label': 'BlackBerry', 'amount': 54}];

      let excelData = [
        {'label': 'Android 8.1', 'amount': 20},
        {'label': 'Android 8.0', 'amount': 56}, 
        {'label': 'Android 9.0', 'amount': 377}, 
        {'label': 'Android 6.0.1', 'amount': 23}, 
        {'label': 'Android 7.0', 'amount': 13}, 
        {'label': 'Android 7.1', 'amount': 45}, 
        {'label': 'Android 10.0', 'amount': 122}, 
        {'label': 'iOS 12.0', 'amount': 86},
        {'label': 'iOS 11.4', 'amount': 154}, 
        {'label': 'iOS 11.3', 'amount': 46}, 
        {'label': 'iOS 11.0', 'amount': 120}, 
        {'label': 'iOS 10.3.3', 'amount': 97}, 
        {'label': 'iOS 10.2', 'amount': 27}, 
        {'label': 'iOS 8.4.1', 'amount': 64}, 
        {'label': 'BlackBerry', 'amount': 54}];

      let data = {
        title : "Devices Used By Attendees",
        dataExcel : excelData,
        data: graphData
      };

      return data;
	  }
  }
}
</script>
<style scoped>
.groupDivide {
	display: flex;
    flex-direction: row;
	flex-wrap: nowrap;
}
.groupItem {
	/* width: 50%;
	margin: 1%; */
}
.featureList {
        display: flex;
        flex-direction: row;
		flex-wrap: wrap;
        justify-content: center;
}
.featureItem {
	max-width: 350px;
}
</style>